import { useState, useRef } from "react";
import { toast } from "react-toastify";
import { useCookies } from "react-cookie";
import http from "../../../common/http-common";
import * as Comp from "../../../common/CommonComponents";
import * as common from "../../../common/common";

const _pageName = "ServerEnvActivator.js";

const ServerEnvActivator = (props) => {
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  //#region Event Handlers
  //#region Modal Show/Hide
  const hideModal = () => {
    props.onHide();
  };
  //#endregion

  //#region Confirm Update Status
  const confirmBtnOnClick = () => {
    UpdateServerEnvStatus(props.editData);
  };

  const UpdateServerEnvStatus = (_data) => {
    let functionName = "";

    try {
      functionName = _pageName + UpdateServerEnvStatus.name;

      props.onLoading(
        true,
        (_data.ACTIVE_FLAG === "Y" ? "Deactivating" : "Activating") +
          " Server, please wait...",
      );
      props.onHide();

      const data = {
        SERVER_ENV_ID: _data.SERVER_ENV_ID,
        SERVER_ENV_NAME: _data.SERVER_ENV_NAME,
        ACTIVE_FLAG: _data.ACTIVE_FLAG,
        UPDATE_ID: userId,
        FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
      };

      http
        .put("api/ServerEnv/UpdateServerEnvStatus", data, { timeout: 5000 })
        .then((response) => {
          const successAction =
            _data.ACTIVE_FLAG === "Y" ? "deactivated" : "activated";
          toast.success("Server is successfully " + successAction + ".");
          props.onReload();
        })
        .catch((err) => {
          const action = _data.ACTIVE_FLAG === "Y" ? "deactivate" : "activate";
          toast.error("Failed to " + action + " Server. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        })
        .finally(() => {
          props.onLoading(false, "Loading...");
        });
    } catch (err) {
      props.onLoading(false, "Loading...");
      const action = _data.ACTIVE_FLAG === "Y" ? "deactivate" : "activate";
      toast.error("Failed to " + action + " model. Please try again.");
      common.c_LogWebError(props.page, functionName, err);
    }
  };
  //#endregion

  const message = (
    <>
      Confirm to{" "}
      {props.editData !== null && props.editData.ACTIVE_FLAG === "Y"
        ? "deactivate"
        : "activate"}
      ? <br /> Server:{" "}
      {<b> {props.editData !== null && props.editData.SERVER_ENV_NAME}</b>}
    </>
  );

  return (
    <>
      <Comp.ConfirmModal
        show={props.showHide}
        onHide={hideModal}
        onConfirm={confirmBtnOnClick}
      >
        {message}
      </Comp.ConfirmModal>
    </>
  );
};

export default ServerEnvActivator;

